module.exports = __webpack_public_path__ + "static/media/cert-2.56c69f26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/security/3/cert-2.svg
// module id = 405
// module chunks = 0